/**
 * Feature Flag Constants
 *
 * Central location for all PostHog feature flag keys.
 * Using constants prevents typos and enables IDE autocomplete.
 *
 * To add a new flag:
 * 1. Create the flag in PostHog dashboard
 * 2. Add the key here as a constant
 * 3. Use the constant in your code
 *
 * @example
 * import { FLAGS } from '../config/featureFlags';
 * const isEnabled = useFeatureFlag(FLAGS.MY_NEW_FEATURE);
 */

/**
 * All feature flag keys used in the application.
 * Keys should match exactly what's configured in PostHog.
 *
 * Add new flags here as needed:
 * MY_FEATURE: 'my-feature',
 */
export const FLAGS = {} as const;

/**
 * Type for flag keys - useful for type-safe flag checking
 */
export type FeatureFlagKey = (typeof FLAGS)[keyof typeof FLAGS];

/**
 * Default values for flags when PostHog is unavailable
 * Used in development or when PostHog fails to load
 */
export const FLAG_DEFAULTS: Record<string, boolean> = {};
